'use client';

import { useCallback, useState } from 'react';

import { defaultPerPageOptions } from '../constants/pagination';
import { getTablePerPageState, setTablePerPageState } from '../utils/tableState';

export function usePagination({
  defaultPerPage = defaultPerPageOptions[0],
  perPageOptions = defaultPerPageOptions,
  tableId,
}: {
  defaultPerPage?: number;
  perPageOptions?: number[];
  tableId: string;
}) {
  const [tablePage, setTablePage] = useState(0);
  const [perPage, setPerPage] = useState(() => {
    const perPageState = getTablePerPageState(tableId);

    if (perPageState && perPageOptions.includes(perPageState)) {
      return perPageState;
    }

    return defaultPerPage;
  });

  const handleSetPerPage = useCallback(
    (perPage: number) => {
      setTablePage(0);
      setPerPage(perPage);
      setTablePerPageState(tableId, perPage);
    },
    [tableId],
  );

  return {
    apiPage: tablePage + 1,
    perPage,
    setPerPage: handleSetPerPage,
    setTablePage,
    tablePage,
  };
}
